var angular = require('angular');
var stripJs = require('strip-js');
require('angular-sanitize');
require('angular-ui-router');
require('ng-idle');
require('angular-lz-string');
require('angular-cookies');
require('angular-ui-carousel');

var appInsights = require('@microsoft/applicationinsights-web');
var appMarketplace = angular
    .module('appMarketplace', ['kendo.directives', 'ui.router', 'ngIdle', 'ngSanitize', 'lz-string', 'ngCookies', 'ui.carousel'])
    .config(['$stateProvider', '$httpProvider', '$locationProvider', 'KeepaliveProvider', 'IdleProvider', 'TitleProvider',
            function ($stateProvider, $httpProvider, $locationProvider, KeepaliveProvider, IdleProvider, TitleProvider) {
        var contextPath = '/' + document.URL.split('/')[3];
        $locationProvider.html5Mode({
            enabled: true,      // prevent adding a slash after a hash sign by AngularJS
            requireBase: false, // don't require <base> html tag
            rewriteLinks: false
        });
        $stateProvider.state('root-state', {
            url: '/'
        }).state('accept-privacy-policy-state', {
            url: '/accept-privacy-policy',
            views: {
                'accept-privacy-policy': {
                    controller: 'AcceptPrivacyPolicyCtrl',
                    templateUrl: contextPath + '/static/view/accept-privacy-policy.html?ver=56a102bca008fa586e0c737006aa40f0'
                }
            }
        }).state('update-password-state', {
            url: '/update-password',
            views: {
                'update-password': {
                    controller: 'UpdatePasswordCtrl',
                    templateUrl: contextPath + '/static/view/update-password.html'
                }
            },
            params: {
                manualUpdate: false
            }
        }).state('update-password-hint-state', {
            url: '/update-password-hint',
            views: {
                'update-password-hint': {
                    controller: 'UpdatePasswordHintCtrl',
                    templateUrl: contextPath + '/static/view/update-password-hint.html'
                }
            },
            params: {
                manualUpdate: false
            }
        }).state('supplier-details-state', {
            views: {
                'supplier-details': {
                    controller: 'SupplierDetailsCtrl',
                    templateUrl: contextPath + '/static/view/supplier-details.html'
                }
            },
            params: {
                supplierId: null
            }
        }).state('catalogue-upload-history-state', {
            views: {
                'catalogue-upload-history': {
                    controller: 'CatalogueUploadHistoryCtrl',
                    templateUrl: contextPath + '/static/view/catalogue-upload-history.html'
                }
            },
            params: {
                supplierId: null,
                catalogueId: null
            }
        }).state('compare-products-state', {
            views: {
                'compare-products': {
                    controller: 'CompareProductsCtrl',
                    templateUrl: contextPath + '/static/view/compare-products.html'
                }
            },
            params: {
                products: null, // array of products to compare
                orgCatalogueAttributes: null, // array of organisation catalogue attributes. Only comparable will be used
                documentId: null
            }
        }).state('basket-item-comments-state', {
            views: {
                'basket-item-comments': {
                    controller: 'BasketItemCommentsCtrl',
                    templateUrl: contextPath + '/static/view/basket-item-comments.html'
                }
            },
            params: {
                item: null
            }
        }).state('basket-item-attachments-state', {
            views: {
                'basket-item-attachments': {
                    controller: 'BasketItemAttachmentsCtrl',
                    templateUrl: contextPath + '/static/view/basket-item-attachments.html'
                }
            },
            params: {
                item: null
            }
        }).state('additional-forms-state', {
            views: {
                'additional-forms': {
                    controller: 'AdditionalFormsCtrl',
                    templateUrl: contextPath + '/static/view/additional-forms.html'
                }
            },
            params: {
                basketId: null,
                formIds: null,
                checkoutOnFinish: false
            }
        }).state('supplier-notes-state', {
            views: {
                'supplier-notes': {
                    controller: 'SupplierNotesCtrl',
                    templateUrl: contextPath + '/static/view/supplier-notes.html'
                }
            },
            params: {
                notes: null
            }
        }).state('unspsc-message-state', {
            views: {
                'unspsc-message': {
                    controller: 'UnspscMessageCtrl',
                    templateUrl: contextPath + '/static/view/unspsc-message.html'
                }
            },
            params: {
                message: null
            }
        }).state('supplier-network-failed-messages-history-state', {
            views: {
                'supplier-network-failed-messages-history': {
                    controller: 'SupplierNetworkFailedMessagesHistoryCtrl',
                    templateUrl: contextPath + '/static/view/failed-messages-history.html'
                }
            },
            params: {
                auditList: null
            }
        }).state('supplier-network-change-password-state', {
            views: {
                'supplier-network-profile-password': {
                    controller: 'SupplierNetworkProfilePasswordCtrl',
                    templateUrl: contextPath + '/static/view/supplier-network-profile-password.html'
                }
            }
        }).state('supplier-network-linking-details-state', {
            views: {
                'supplier-network-linking-details': {
                    controller: 'SupplierNetworkLinkingDetailsCtrl',
                    templateUrl: contextPath + '/static/view/supplier-network-linking-details.html'
                }
            }
        }).state('supplier-network-linking-result-state', {
            views: {
                'supplier-network-linking-result': {
                    controller: 'SupplierNetworkLinkingResultCtrl',
                    templateUrl: contextPath + '/static/view/supplier-network-linking-result.html'
                }
            }
        }).state('create-delivery-scheme-state', {
            views: {
                'create-delivery-scheme': {
                    controller: 'CreateDeliverySchemeCtrl',
                    templateUrl: contextPath + '/static/view/create-delivery-scheme.html'
                }
            },
            params: {
                vendorId: null,
                orgUnitId: null
            }
        }).state('edit-text-based-delivery-scheme-state', {
            views: {
                'edit-text-based-delivery-scheme': {
                    controller: 'EditTextBasedDeliverySchemeCtrl',
                    templateUrl: contextPath + '/static/view/edit-text-based-delivery-scheme.html'
                }
            },
            params: {
                scheme: null
            }
        }).state('edit-rule-based-delivery-scheme-state', {
            views: {
                'edit-rule-based-delivery-scheme': {
                    controller: 'EditRuleBasedDeliverySchemeCtrl',
                    templateUrl: contextPath + '/static/view/edit-rule-based-delivery-scheme.html'
                }
            },
            params: {
                scheme: null
            }
        }).state('modify-item-images-state', {
            views: {
                'modify-item-images': {
                    controller: 'ModifyItemImagesCtrl',
                    templateUrl: contextPath + '/static/view/modify-item-images.html'
                }
            },
            params: {
                item: null
            }
        }).state('create-app-insights-property-state', {
            views: {
                'create-app-insights-property': {
                    controller: 'CreateAppInsightsPropertyCtrl',
                    templateUrl: contextPath + '/static/view/create-app-insights-property.html'
                }
            }
        }).state('edit-app-insights-property-state', {
            views: {
                'edit-app-insights-property': {
                    controller: 'EditAppInsightsPropertyCtrl',
                    templateUrl: contextPath + '/static/view/edit-app-insights-property.html'
                }
            },
            params: {
                appInsightsProperty: null
            }
        });

        $httpProvider.interceptors.push('sessionExpiredInterceptor');
        $httpProvider.interceptors.push('responseErrorInterceptor');

        IdleProvider.idle(600); // 10 minutes
        IdleProvider.timeout(3600); // 1 hour, does not matter, actually, but should be greater than the length of the session, so that IdleProvider works all the time and handles KeepaliveProvider
        IdleProvider.keepalive(true);
        TitleProvider.enabled(false);
        KeepaliveProvider.interval(300); // 5 minutes
        KeepaliveProvider.http(contextPath + '/renew_session.jsp');
    }])
    .constant('navigationStyle', {
        'System': 'glyphicons glyphicons-cogwheels',
        'reports': 'glyphicons glyphicons-charts',
        'Administration': 'glyphicons glyphicons-settings',
        'Orders': 'glyphicons glyphicons-more-items',
        'Finance': 'glyphicons glyphicons-wallet',
        'home': 'glyphicons glyphicons-home',
        'Catalogue': 'glyphicons glyphicons-book-open',
        'E-Invoicing': 'glyphicons glyphicons-note',
        'More': 'glyphicons glyphicons-show-lines'
    })
    .constant('dataAttributes', {
        'home': 'data-home-link'
    })
    .constant('compareProducts', {
        minItemSize: 2,
        maxItemSize: 4
    })
    .filter('firstExactMatch', [function firstExactMatchFilter() {
        /**
         * Unlike standard angularJS filter, immediately returns value when the first match was found.
         */
        return function filterCallback(array, predicate) {
            if (!array) {
                return null;
            }

            var predicateKeys = Object.keys(predicate);
            var arrayKeys = Object.keys(array);
            for (var i = 0; i < arrayKeys.length; i++) {
                var arrayKey = arrayKeys[i];
                var value = array[arrayKey];
                var matchesAll = true;
                for (var j = 0; j < predicateKeys.length; j++) {
                    var predicateKey = predicateKeys[j];
                    if (value[predicateKey] !== predicate[predicateKey]) {
                        matchesAll = false;
                        break;
                    }
                }
                if (matchesAll) {
                    return value;
                }
            }
            return null;
        };
    }])
    .filter('trusted', ['$sce', function ($sce) {
        return $sce.trustAsHtml;
    }])
    .filter('formatDate', [function toDateFilter() {
        /**
         * Returns date in specified format.
         * If format is not specified then it uses yyyy-MM-dd pattern.
         */
        return function filterCallback(value, format) {
            if (!value) {
                return null;
            }
            return kendo.toString(value, format || "yyyy-MM-dd");
        };
    }])
    .run(['$rootScope', 'Idle', 'Carousel', 'AppInsightsConfigService', function ($rootScope, Idle, Carousel, AppInsightsConfigService) {
        $rootScope.stripJs = stripJs;

        Idle.watch();

        $rootScope.$on('domChanged', function domChanged(event, element) {
            var el = element || angular.element(document.body);
            el.find('a:not([target]):not([ui-sref])').attr('target', '_self'); //note that target="_self" breaks angular's ui-sref
            // a link inside a kendo menu shouldn't be accessible using the Tab key, but it is accessible by default
            el.find('[data-home-link]').parent().attr("tabindex", -1);
        });
        $rootScope.$emit('domChanged'); // without this links that leads to the same page won't work (menu, for instance)

        AppInsightsConfigService.getAppInsightsConfig(function (data) {
            var config = {config: {}};
            var props = data.properties;
            props.forEach(function(prop) {
                var value = prop.value;

                if (!isNaN(parseFloat(value)) && isFinite(value)) {
                    config.config[prop.key] = parseInt(value);
                } else if (value === "false" || value === "true") {
                    config.config[prop.key] = (value === 'true');
                } else {
                    config.config[prop.key] = value;
                }
            });

            if(config.config.instrumentationKey !==''){
                var appInsightsService = new appInsights.ApplicationInsights(config);

                var telemetryInitializer = function (envelope){
                        function adjustPageName(item) {
                            var pageviewRenames = JSON.parse(config.config["pageviewRenames"]);

                            for (var page in pageviewRenames) {
                                if (item.name.indexOf(page) !== -1){
                                    return pageviewRenames[page];
                                }
                            }
                            return item.name;
                        }

                    var telemetryItem = envelope.baseData;
                    if (envelope.name === appInsights.Telemetry.PageView.envelopeType || envelope.name === appInsights.Telemetry.PageViewPerformance.envelopeType) {
                        telemetryItem.name = adjustPageName(telemetryItem);
                    }
                };
                appInsightsService.loadAppInsights();
                appInsightsService.addTelemetryInitializer(telemetryInitializer);
                appInsightsService.trackPageView();
            }
        },function (responseError){
            NotificationService.showErrorMessage(responseError.message);
        });

        Carousel.setOptions({
            arrows: true,
            autoplay: false,
            autoplaySpeed: 3000,
            cssEase: 'ease',
            easing: 'linear',
            fade: true,
            infinite: false,
            initialSlide: 0,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500
        });
    }]);



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/angular-main.js
// module id = 203
// module chunks = 37